import { Fade, Progress, Card, CardBody } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../common/containers/icon';
const DocumentsUploadProgress = props => {
  const total = props.total,
    progressPercent = props.progressPercent;
  let numDone = 0;
  // count the number of files to indicate how many have been uploaded
  if (total > 0 && progressPercent > -1) {
    numDone = Math.round(total * progressPercent / 100);
  }
  const progressInstance = progressPercent > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fade, {
    in: progressPercent > -1 && progressPercent < 100
  }, /*#__PURE__*/React.createElement(Progress, {
    active: "true",
    value: progressPercent
  }))) : /*#__PURE__*/React.createElement(Progress, {
    value: 0
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
    className: "card-heading upload-counter"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download"
  }), " uploaded (".concat(numDone, "/").concat(total, ")"), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '10px'
    }
  }), progressInstance, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fade, {
    in: progressPercent < 0
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-dup-upload-title",
    style: {
      marginTop: '20px'
    }
  }, "Select Files to Upload")), /*#__PURE__*/React.createElement(Fade, {
    in: progressPercent === 100
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-dup-upload-complete",
    style: {
      marginBottom: '10px'
    }
  }, "Upload Completed!"))))));
};
DocumentsUploadProgress.propTypes = {
  progressPercent: PropTypes.number.isRequired,
  // -1 to 100
  total: PropTypes.number.isRequired // 0 to n
};
export default DocumentsUploadProgress;